/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ScholarshipFileApprovalTypeFileViewModel } from "../types/ScholarshipFileApprovalTypeFileViewModel.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";
import { scholarshipFileApprovalAttachmentViewModelSchema } from "./scholarshipFileApprovalAttachmentViewModelSchema.ts";

export const scholarshipFileApprovalTypeFileViewModelSchema = z.object({
  scholarshipTypeFileId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do tipo de documento. É o valor aceito nos endpoints de status, aprovação e upload.",
      ),
  ),
  scholarshipTypeId: z.optional(
    z
      .number()
      .int()
      .describe("ID do tipo de bolsa ao qual o documento pertence."),
  ),
  personId: z.optional(z.number().int().describe("ID do aluno.")),
  description: z.string().describe("Nome do documento exigido.").nullish(),
  instruction: z
    .string()
    .describe("Instruções de envio do documento. Pode conter HTML. Opcional.")
    .nullish(),
  templateFile: z
    .string()
    .describe(
      "Caminho do arquivo-modelo cadastrado no tipo de documento. Opcional.",
    )
    .nullish(),
  templateFileName: z
    .string()
    .describe("Nome original do arquivo-modelo. Opcional.")
    .nullish(),
  isMandatory: z.optional(
    z.boolean().describe("Indica se o documento é obrigatório."),
  ),
  mandatoryLabel: z
    .string()
    .describe(
      'Rótulo de obrigatoriedade pronto para exibição: "Obrigatório" ou "Obrigatório, caso se enquadre". No legado era montado na view.',
    )
    .nullish(),
  generateFormLink: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o tipo de documento gera link de formulário externo.",
      ),
  ),
  generateCandidatePortalLink: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o tipo de documento gera link do portal do candidato.",
      ),
  ),
  active: z.optional(
    z.boolean().describe("Indica se o tipo de documento está ativo na bolsa."),
  ),
  hasAttachments: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o aluno anexou algum arquivo para este tipo de documento.",
      ),
  ),
  approvalStatus: z.optional(
    z
      .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
      .describe(
        "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  rejectionReason: z
    .string()
    .describe("Justificativa da reprova. Vazia quando não há.")
    .nullish(),
  hasRejectionReason: z.optional(
    z
      .boolean()
      .describe(
        "Indica se há justificativa registrada. No legado habilitava o botão na tela.",
      ),
  ),
  rejectionReasonLabel: z
    .string()
    .describe(
      'Rótulo do botão de justificativa: "Motivo de reprova" quando reprovado, "Relembrar motivo de reprova" nos demais casos.',
    )
    .nullish(),
  attachments: z
    .array(z.lazy(() => scholarshipFileApprovalAttachmentViewModelSchema))
    .describe(
      "Anexos do aluno para este tipo de documento, em ordem cronológica. O mais recente vem pré-selecionado.",
    )
    .nullish(),
}) as unknown as ToZod<ScholarshipFileApprovalTypeFileViewModel>;
